import apiClient from "../apiClient";

const endpoint = "/api/teams/";

export const getTeams = async () => {
  const response = await apiClient.get(endpoint);
  return response.data;
};

export const getTeam = async (id) => {
  const response = await apiClient.get(`${endpoint}${id}/`);
  return response.data;
};

export const createTeam = async (data) => {
  const response = await apiClient.post(endpoint, data);
  return response.data;
};

export const updateTeam = async (id, data) => {
  const response = await apiClient.put(`${endpoint}${id}/`, data);
  return response.data;
};

export const deleteTeam = async (id) => {
  const response = await apiClient.delete(`${endpoint}${id}/`);
  return response.data;
};

export const getMyTeams = async () => {
  const response = await apiClient.get(`${endpoint}my_teams/`);
  return response.data;
};

export const addPlayerToTeam = async (teamId, playerId) => {
  const response = await apiClient.post(`${endpoint}${teamId}/add_player/`, {
    player_id: playerId
  });
  return response.data;
};

export const removePlayerFromTeam = async (teamId, playerId) => {
  const response = await apiClient.post(`${endpoint}${teamId}/remove_player/`, {
    player_id: playerId
  });
  return response.data;
};
